// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import CONSTANT from "../../../constant"
import { useState } from "react"

const TimeCardGrid: React.FC<{
  isRestoreSearching: boolean
  setIsRestoreSearching: React.Dispatch<React.SetStateAction<boolean>>
  dakokuGridData: {
    data: wjCore.CollectionView
  }
  setDakokuGridData: React.Dispatch<
    React.SetStateAction<{
      data: wjCore.CollectionView
    }>
  >
}> = (props) => {
  const dakokuCountGridId = "zyomuinSyukkinbo_dakokuCountGridId"
  const [dakokuFlexGrid, setDakokuFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [dakokuPageSize, setDakokuPageSize] = useState<number>(100)
  const [dakokuPageNumber] = useState<number>(0)
  const [dakokuGridInitialized, setDakokuGridInitialized] =
    useState<boolean>(false)

  // グリッド初期化時イベントハンドラ
  const dakokuGridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.refresh()
  }

  return (
    <FlexGridOuter
      flexGrid={dakokuFlexGrid}
      setFlexGrid={setDakokuFlexGrid}
      hasFilter={false}
      gridConstantProperties={CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
      gridData={props.dakokuGridData}
      setGridData={props.setDakokuGridData}
      pageNumber={dakokuPageNumber}
      gridId={dakokuCountGridId}
      isRestoreSearching={props.isRestoreSearching}
      setIsRestoreSearching={props.setIsRestoreSearching}
      gridInitialized={dakokuGridInitialized}
      setGridInitialized={setDakokuGridInitialized}
      isEnablePageSize={"hidden"}
      isShowGridHeader={false}
      isShowGridFooter={false}
      pageSize={dakokuPageSize}
      setPageSize={setDakokuPageSize}
      gridInitializedHandler={dakokuGridInitializedHandler}
      gridProperties={{
        headersVisibility: wjcGrid.HeadersVisibility.Column,
        isReadOnly: false,
        stickyHeaders: false,
      }}
      isShowGridRowPickupButton={false}>
      <wjrGrid.FlexGridColumn
        binding="勤務日"
        width={80}
        isReadOnly={true}
        cssClass={"read-only-cell"}
        header="勤務日"></wjrGrid.FlexGridColumn>
      <wjrGrid.FlexGridColumn
        binding="出退勤区分名称1"
        width={80}
        align={"center"}
        cssClass={"read-only-cell"}
        isRequired={false}
        header="出退勤区分"></wjrGrid.FlexGridColumn>
      <wjrGrid.FlexGridColumn
        binding="出勤時間"
        width={90}
        align={"center"}
        cssClass={"read-only-cell"}
        isReadOnly={true}
        isRequired={false}
        header="出勤時刻"
        format={"t"}></wjrGrid.FlexGridColumn>
      <wjrGrid.FlexGridColumn
        binding="退勤時間"
        isRequired={false}
        cssClass={"read-only-cell"}
        isReadOnly={true}
        width={90}
        align={"center"}
        header="退勤時刻"
        format={"HH:mm"}></wjrGrid.FlexGridColumn>
    </FlexGridOuter>
  )
}

export default TimeCardGrid
